import { FC, ReactElement, Children, cloneElement, MouseEvent } from 'react';
import { TabGroupProps } from './TabGroup.types';
import { TabGroupStyled } from './TabGroup.styles';
import { getPanelId, getTabId } from '@components/helpers/tab';
import { useTabContext } from '@components/hooks';

const TabGroup: FC<TabGroupProps> = (props) => {
  const { children: childrenProp, css, onChange, tabSize } = props;

  const tabContext = useTabContext();

  if (tabContext === undefined) {
    throw new Error('No TabContext provided.');
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>, value: string): void => {
    onChange?.(event, value);
    tabContext.setActiveTab(value);
  };

  const activeTab = tabContext?.activeTab;

  const children = Children.map(childrenProp, (child: ReactElement) => {
    const childValue = child.props.value;
    const isTabSelected = childValue === activeTab;

    const tabId = getTabId(tabContext.idPrefix, childValue);
    const panelId = getPanelId(tabContext.idPrefix, childValue);

    return cloneElement(child, {
      id: tabId,
      onClick: handleClick,
      panelId,
      selected: isTabSelected,
      size: tabSize,
    });
  });

  return (
    <TabGroupStyled css={css} role="tablist">
      {children}
    </TabGroupStyled>
  );
};

export default TabGroup;
